import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import styles from "./Levels.css";
import Dialog from "../Dialog/Dialog";
import Scrollable from "../Scrollable/Scrollable";

export default class Levels extends Component {
  render = () => {
    const { show, levels, current } = this.props;

    if (!levels) return null;

    const choices = levels.map(level => (
      <li
        key={level.id}
        className={`${styles.level} ${
          current === level.id + 1 ? styles.active : ""
        } ${!level.available ? styles.disabled : ""}`}
        value={level.id + 1}
        onClick={this.handleChangeClick(level)}
      >
        <div className={styles.badge}>{level.id + 1}</div>
        <section className={styles.description}>
          <h1 className={styles.title}>{level.title}</h1>
          <ul className={styles.features}>
            {level.desc.map((text, i) => (
              <li key={i}>{text}</li>
            ))}
          </ul>
        </section>
      </li>
    ));

    return (
      <div className={`${styles.levels} ${show && styles.show}`}>
        <Dialog
          onClose={this.handleCloseClick}
          heading={I18n.t("levels.heading")}
        >
          <Scrollable className={styles.wrapper}>
            <ul className={styles.list}>{choices}</ul>
          </Scrollable>
        </Dialog>
      </div>
    );
  };

  handleCloseClick = () => this.props.hideLevels();

  handleChangeClick = level => () => {
    level.available
      ? this.props.setLevel(level.id + 1)
      : this.props.showPaywall();
  };
}



// WEBPACK FOOTER //
// ./src/components/Levels/Levels.js